import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataRr from './phonics/phonics_data_rr';

function PhonicsRr() {
  return <PhonicsAtoZ letterData={letterDataRr} />;
}

export default PhonicsRr;
